
namespace MACRAIL.UI {

export class Snackbar {

    public static minDisplayTime = 4000;

    public static show(statusClass: string, message: string): void;
    public static show(message: string): void;
    public static show(message: SnackbarMessage): void;
    public static show(arg1: any, arg2?: any): void {

        if (typeof arg1 === 'string' && arg2 === undefined) {
            this.messages.push({
                'class': 'default',
                'message': arg1,
            });
        } else if (typeof arg2 === 'string') {
            this.messages.push({
                'class': arg1,
                'message': arg2,
            });
        } else {
            this.messages.push(arg1);
        }

        if (!this.processing) {
            this.showNextMessage();
        }
    }

    /**
     * Show a test message with a random class.
     */
    public static test (): void {
        let states: StatusClass[] = ['default', 'primary', 'info', 'success', 'warning', 'danger'];

        MACRAIL.UI.Snackbar.show({
            'class': states[Math.floor(Math.random() * 6)],
            'message': new Date().toString(),
        });
    }

    private static element: JQuery;
    private static timer?: number;
    private static messages: SnackbarMessage[] = [];
    private static processing: boolean = false;

    private static showNextMessage() {
        this.processing = true;

        this.createElement();

        if (this.messages.length === 0) {
            return;
        }

        let message = this.messages.splice(0, 1)[0];

        this.element.prop('class', message.class);

        this.element.text(message.message);
        this.element.height();
        this.element.addClass('active');

        this.timer = window.setTimeout(this.closeMessage.bind(this), this.minDisplayTime);
    }

    private static closeMessage() {
        this.element.removeClass('active');

        // If we have more to show, set a timeout to show the next one.
        if (this.messages.length) {
            this.timer = window.setTimeout(this.showNextMessage.bind(this), 1000);
        } else {
            // We're done!
            this.processing = false;
        }
    }

    private static createElement() {
        if (this.element !== undefined) {
            return;
        }

        this.element = $('<div id="snackbar">').appendTo(document.body);
    }

}

}

interface SnackbarMessage {
    class: StatusClass;
    message: string;
}
